export default {
  namespaced: true,
  state: {
    windowSizes: {
      height: window.innerHeight,
      width: window.innerWidth,
    },
    scroll: {
      scrolled: window.scrollY > 0,
      value: window.scrollY
    }
  },
  getters: {
    getScroll: (state) => state.scroll,
    getWindow: (state) => state.windowSizes,
  },
  mutations: {
    UPDATE_WINDOWS (state, status) {
      state.windowSizes = status
    },
    UPDATE_RESIZE (state, status) {
      state.scroll = status
    }
  },
  actions: {
    updateWindow ({ commit }, status) {
      commit('UPDATE_WINDOWS', status)
    },
    updateResize ({ commit }, status) {
      commit('UPDATE_RESIZE', status)
    },
  }
}
